import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "permission"];

  connect() {
    this._onClick = this.hide.bind(this);
    document.addEventListener("click", this._onClick);
    this.registerServiceWorker();
    this.requestPermission();
  }

  disconnect() {
    document.removeEventListener("click", this._onClick);
  }

  toggle() {
    if (this.panelTarget.classList.contains("hidden")) {
      this.panelTarget.classList.remove("hidden");
      void this.panelTarget.offsetWidth;
      this.panelTarget.classList.add("ui-menu--open");
    } else {
      this.panelTarget.classList.remove("ui-menu--open");
      this.panelTarget.classList.add("hidden");
    }
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.panelTarget.classList.remove("ui-menu--open");
      this.panelTarget.classList.add("hidden");
    }
  }

  async requestPermission() {
    if (!("Notification" in window)) return;
    if (Notification.permission !== "default") {
      this.hidePermissionBanner();
      return;
    }

    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") this.hidePermissionBanner();
    } catch {
      // ignore
    }
  }

  hidePermissionBanner() {
    this.permissionTarget?.classList.add("hidden");
  }

  async registerServiceWorker() {
    if (!("serviceWorker" in navigator)) return;
    try {
      await navigator.serviceWorker.register("/service-worker.js", { scope: "/" });
    } catch {
      // ignore
    }
  }
}
